import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import contract from '@/components/contract.vue'
import contactus from '../views/contactus.vue' //联系我们
import hire from '../views/hire.vue' //招贤纳士
import download from '../views/download.vue' //招贤纳士
import about from '../views/about.vue' //关于我们
import aboutus from '../views/aboutus.vue' //关于我们
import case1 from '../views/case.vue' //案例
import medium from '../views/medium.vue' //媒体
import product from '../views/product.vue' //产品
import productdetails from '../views/productdetails.vue' //产品详情
import service from '../views/service.vue' //服务
import mediumdetails from '../views/mediumdetails.vue' //媒体

import enHomeView from "../views/en/HomeView.vue";
import encontactus from '../views/en/contactus.vue' //联系我们
import enhire from '../views/en/hire.vue' //招贤纳士
import endownload from '../views/en/download.vue' //招贤纳士
import enabout from '../views/en/about.vue' //关于我们
import encase1 from '../views/en/case.vue' //案例
import enmedium from '../views/en/medium.vue' //媒体
import enproduct from '../views/en/product.vue' //产品
import enproductdetails from '../views/en/productdetails.vue' //产品详情
import enservice from '../views/en/service.vue' //服务
import enmediumdetails from '../views/en/mediumdetails.vue' //媒体

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "index",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: about,
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: aboutus,
  },
  
  {
    path: "/contract",
    name: "contract",
    component: contract,
  },
  {
    path: "/hire",
    name: "hire",
    component: hire,
  },
  {
    path: "/contactus",
    name: "contactus",
    component: contactus,
  },
  {
    path: "/download",
    name: "download",
    component: download,
  },
  
  
  {
    path: "/about",
    name: "about",
    component: about,
  },
  {
    path: "/case",
    name: "case",
    component: case1,
  },
  {
    path: "/medium",
    name: "medium",
    component: medium,
  },
  {
    path: "/mediumdetails",
    name: "mediumdetails",
    component: mediumdetails,
  },
  {
    path: "/product",
    name: "product",
    component: product,
  },
  {
    path: "/productdetails",
    name: "productdetails",
    component: productdetails,
  },
  
  {
    path: "/service",
    name: "service",
    component: service,
  },
  
  
  
  
  {
    path: "/en/",
    name: "enindex",
    component: enHomeView,
  },
  {
    path: "/en/about",
    name: "enabout",
    component: enabout,
  },
  
  {
    path: "/en/hire",
    name: "enhire",
    component: enhire,
  },
  {
    path: "/en/contactus",
    name: "encontactus",
    component: encontactus,
  },
  {
    path: "/en/download",
    name: "endownload",
    component: endownload,
  },
  
  
  {
    path: "/en/about",
    name: "enabout",
    component: enabout,
  },
  {
    path: "/en/case",
    name: "encase",
    component: encase1,
  },
  {
    path: "/en/medium",
    name: "enmedium",
    component: enmedium,
  },
  {
    path: "/en/mediumdetails",
    name: "enmediumdetails",
    component: enmediumdetails,
  },
  {
    path: "/en/product",
    name: "enproduct",
    component: enproduct,
  },
  {
    path: "/en/productdetails",
    name: "enproductdetails",
    component: enproductdetails,
  },
  
  {
    path: "/en/service",
    name: "enservice",
    component: enservice,
  }
  
  
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
